/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Deep_Otter_SwimInputs */

const en_warm_deep_otter_swim = /** @type {(inputs: Warm_Deep_Otter_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages`)
};

const de_warm_deep_otter_swim = /** @type {(inputs: Warm_Deep_Otter_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen`)
};

/**
* | output |
* | --- |
* | "Languages" |
*
* @param {Warm_Deep_Otter_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_deep_otter_swim = /** @type {((inputs?: Warm_Deep_Otter_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Deep_Otter_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_deep_otter_swim(inputs)
	return de_warm_deep_otter_swim(inputs)
});